import React from "react";
import Button from "@material-ui/core/Button";
import styled from "styled-components";

const StyledButton = styled(Button)`
  &:hover {
    background-color: ${(props) => (props.special ? "#fff" : "#2498FB")};
  }
  background-color: ${(props) => (props.special ? "#fff" : "#2498FB")};
  box-shadow: 0px 14px 30px #00000029;
  border-radius: 15px;
  opacity: 1;
  color: ${(props) => props.color || "#fff"};
  width: ${(props) => props.width || "282px"};
  max-width: ${(props) => props.maxWidth || "282px"};
  height: ${(props) => props.height || "56px"};
  font-size: 1em;
  padding: 0.25em 1em;
  border-radius: 8px;
  @media only screen and (max-width: 767px) {
    max-width: ${(props) => props.maxWidth || "200px"};
  }
  margin-right: 30px;
`;

export { StyledButton };
